let k_notification = null;

export default function () {
    createNotification();
    
    // setInterval(showSuccessNotification, 10000)
    // setInterval(showInfoNotification, 10000)
    // setInterval(showWarningNotification, 10000)
    // setInterval(showErrorNotification, 10000)
}

const createNotification = () => {
    let $notification = $(document.createElement('div')),
        k_template = kendo.template('<div class="notificationPopUp --#= icon #" style="text-align:center;padding : 10px"><div><span class="k-icon k-i-#= icon #" style="width:25px;"></span>#= message #</div></div>');
    document.body.appendChild($notification[0]);
    k_notification = $notification.kendoNotification({
        width       : '12em', position: {
            pinned: true, bottom: 30, left: 30
        }, templates: [
            {
                type: 'error', template: k_template
            }, {
                type: 'success', template: k_template
            }, {
                type: 'info', template: k_template
            }, {
                type: 'warning', template: k_template
            }
        ]
    }).data('kendoNotification');
};

const showNotification = (type, msg) => {
    if (type != null) {
        k_notification.show({
            icon: type, 
            message: msg || type, 
            autoHideAfter: 15000
        }, type);
    }
};

export const showSuccessNotification = function (msg) {
    showNotification('success', msg || 'Form Saved!');
};
export const showErrorNotification = function (msg) {
    showNotification('error', msg || 'Error Saving Form!');
};
export const showInfoNotification = function (msg) {
    showNotification('info', msg || 'Info');
};
export const showWarningNotification = function (msg) {
    showNotification('warning', msg || 'Watch Out!');
};